import "@/App.css";
import "@/app-shell.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import { AuthProvider } from "@/lib/auth";
import PwaInstallPrompt from "@/components/PwaInstallPrompt";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Funnel from "@/pages/Funnel";
import Gracias from "@/pages/Gracias";
import Privacidad from "@/pages/Privacidad";
import Terminos from "@/pages/Terminos";
import PagoCancelado from "@/pages/PagoCancelado";
import Login from "@/pages/auth/Login";
import Registro from "@/pages/auth/Registro";
import ClientDashboard from "@/pages/cliente/Dashboard";
import Beneficiarios from "@/pages/cliente/Beneficiarios";
import SolicitarAsistencia from "@/pages/cliente/SolicitarAsistencia";
import Historial from "@/pages/cliente/Historial";
import MiPlan from "@/pages/cliente/MiPlan";
import Referidos from "@/pages/cliente/Referidos";
import Salud from "@/pages/cliente/Salud";
import Onboarding from "@/pages/cliente/Onboarding";
import PagoExito from "@/pages/cliente/PagoExito";
import AdminDashboard from "@/pages/admin/Dashboard";
import AdminMiembros from "@/pages/admin/Miembros";
import AdminSolicitudes from "@/pages/admin/Solicitudes";
import AdminAudit from "@/pages/admin/Audit";
import AdminWhatsapp from "@/pages/admin/Whatsapp";
import AdminSecurity from "@/pages/admin/Security";
import AdminCRM from "@/pages/admin/CRM";
import AdminInfluencers from "@/pages/admin/Influencers";
import AuthCallback from "@/pages/auth/AuthCallback";
import ConsultaFolio from "@/pages/ConsultaFolio";
import NotFound from "@/pages/NotFound";
import RegistroAfiliado from "@/pages/afiliados/RegistroAfiliado";
import SociosLogin from "@/pages/afiliados/SociosLogin";
import PortalAfiliado from "@/pages/afiliados/PortalAfiliado";
import CampanaInfluencers from "@/pages/afiliados/CampanaInfluencers";
import PagosSocio from "@/pages/afiliados/PagosSocio";
import RegistroProveedor from "@/pages/proveedor/RegistroProveedor";
import LoginProveedor from "@/pages/proveedor/LoginProveedor";
import PortalProveedor from "@/pages/proveedor/PortalProveedor";
import AdminPagos from "@/pages/admin/Pagos";
import { RouteTracker } from "@/lib/analytics";
import { captureAttribution } from "@/lib/attribution";
import { initPixels } from "@/lib/pixels";

function App() {
  captureAttribution();
  initPixels();
  return (
    <div className="App">
      <HelmetProvider>
        <AuthProvider>
          <BrowserRouter>
          <RouteTracker />
          <WhatsAppFloat />
          <Routes>
            <Route path="/" element={<Funnel />} />
            <Route path="/activar" element={<Funnel />} />
            <Route path="/gracias" element={<Gracias />} />
            <Route path="/completo" element={<Landing />} />
            <Route path="/privacidad" element={<Privacidad />} />
            <Route path="/terminos" element={<Terminos />} />
            <Route path="/pago/cancelado" element={<PagoCancelado />} />
            <Route path="/cuenta/login" element={<Login />} />
            <Route path="/cuenta/registro" element={<Registro />} />
            <Route path="/auth/callback" element={<AuthCallback />} />

            <Route path="/cuenta" element={<ProtectedRoute><ClientDashboard /></ProtectedRoute>} />
            <Route path="/cuenta/beneficiarios" element={<ProtectedRoute><Beneficiarios /></ProtectedRoute>} />
            <Route path="/cuenta/solicitar" element={<ProtectedRoute><SolicitarAsistencia /></ProtectedRoute>} />
            <Route path="/cuenta/historial" element={<ProtectedRoute><Historial /></ProtectedRoute>} />
            <Route path="/cuenta/plan" element={<ProtectedRoute><MiPlan /></ProtectedRoute>} />
            <Route path="/cuenta/referidos" element={<ProtectedRoute><Referidos /></ProtectedRoute>} />
            <Route path="/cuenta/salud" element={<ProtectedRoute><Salud /></ProtectedRoute>} />
            <Route path="/cuenta/onboarding" element={<ProtectedRoute><Onboarding /></ProtectedRoute>} />
            <Route path="/cuenta/pago/exito" element={<ProtectedRoute><PagoExito /></ProtectedRoute>} />
            <Route path="/cuenta/consultar" element={<ConsultaFolio />} />
            <Route path="/cuenta/:folio" element={<ConsultaFolio />} />

            <Route path="/admin" element={<ProtectedRoute requireRole="admin"><AdminDashboard /></ProtectedRoute>} />
            <Route path="/admin/crm" element={<ProtectedRoute requireRole="admin"><AdminCRM /></ProtectedRoute>} />
            <Route path="/admin/influencers" element={<ProtectedRoute requireRole="admin"><AdminInfluencers /></ProtectedRoute>} />
            <Route path="/admin/miembros" element={<ProtectedRoute requireRole="admin"><AdminMiembros /></ProtectedRoute>} />
            <Route path="/admin/solicitudes" element={<ProtectedRoute requireRole="admin"><AdminSolicitudes /></ProtectedRoute>} />
            <Route path="/admin/audit" element={<ProtectedRoute requireRole="admin"><AdminAudit /></ProtectedRoute>} />
            <Route path="/admin/whatsapp" element={<ProtectedRoute requireRole="admin"><AdminWhatsapp /></ProtectedRoute>} />
            <Route path="/admin/security" element={<ProtectedRoute requireRole="admin"><AdminSecurity /></ProtectedRoute>} />
            <Route path="/socios/registro" element={<RegistroAfiliado />} />
            <Route path="/socios/campana" element={<CampanaInfluencers />} />
            <Route path="/socios/login" element={<SociosLogin />} />
            <Route path="/socios/pagos" element={<ProtectedRoute requireRole="afiliado"><PagosSocio /></ProtectedRoute>} />
            <Route path="/socios" element={<ProtectedRoute requireRole="afiliado"><PortalAfiliado /></ProtectedRoute>} />
            <Route path="/proveedor/registro" element={<RegistroProveedor />} />
            <Route path="/proveedor/login" element={<LoginProveedor />} />
            <Route path="/proveedor" element={<ProtectedRoute requireRole="proveedor"><PortalProveedor /></ProtectedRoute>} />
            <Route path="/admin/pagos" element={<ProtectedRoute requireRole="admin"><AdminPagos /></ProtectedRoute>} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
        <PwaInstallPrompt />
        </AuthProvider>
      </HelmetProvider>
    </div>
  );
}

export default App;
